import React from 'react'
import CustomerList from '../components/CustomerList/CustomerList'

export default function Customers() {
  return (
    <CustomerList />
  )
}
